export class AutoReportSchedule {
    public recId: number = 0;
    public report: string = '';
    public period: string = '';
    public recipients: string = '';
}

